<template>
  <component :is="iconComponentName" :class="className" />
</template>

<script>
import bemBlockModifiers from "@/utils/bem-block-modifiers"

import * as AppIcons from "/wds/sprites/app"
import * as CategoryIcons from "/wds/sprites/category"

export default {
  name: "Sprite",
  components: {
    ...AppIcons,
    ...CategoryIcons
  },
  props: {
    id: { type: String, required: true },
    modifiers: { type: Array, default: () => [] }
  },
  computed: {
    iconComponentName() {
      let [namespace, name] = this.id.split("/")
      return `${namespace}-${name}-icon`
    },
    className() {
      let className = this.id.split("/")
      className = className.concat(this.modifiers)
      return bemBlockModifiers("sprite-vue", className)
    }
  }
}
</script>

<style lang="scss">
.sprite-vue {
  fill: currentColor;

  &--category,
  &--app {
    display: block;
    width: $basex3;
    height: $basex3;
  }
}
</style>
